define(function (require, exports) {
    'use strict';

    // @ngInject
    /**
     * @param {ng.ILogService} $log
     */
    exports.mbMessageValues = function ($log) {
        return {
            link: function (scope, element) {
                var notification = scope.notification;
                if (!notification) {
                    $log.warn('mb-message-values: $scope.notification does not exist. Aborting.');
                    return false;
                }
                var message = notification.message;
                element.html(message);
            }
        };
    };

    exports.metNotification = function () {
        return {
            restrict: 'E',
            scope: {
                level: '@',
                icon: '@'
            },
            replace: true,
            transclude: true,
            template: '<div class="metro-notification">' +
            '   <div class="{{level}}">' +
            '       <div class="notification-item">' +
            '           <div class="metro-notification-icon-wrapper">' +
            '               <div class="metro-notification-icon">' +
            '                   <i class="fa fa-{{icon}}"></i>' +
            '               </div>' +
            '           </div>' +
            '           <div class="metro-notification-body">' +
            '               <div class="metro-notification-message" ng-transclude></div>' +
            '           </div>' +
            '       </div>' +
            '   </div>' +
            '</div>'
        };
    };

    exports.metMessages = function () {
        return {
            restrict: 'E',
            scope: {
                messages: '=',
                showDetail: '='
            },
            replace: true,
            template: '<ul>' +
            '   <li ng-repeat="message in messages track by $index" data-notification-id="{{message.id}}" data-notification-category="{{message.category}}">' +
            '       <div class="metro-notification" data-ng-hide="!message.show">' +
            '           <div class="{{message.level}}">' +
            '               <div class="notification-item">' +
            '                   <div class="metro-notification-icon-wrapper">' +
            '                       <div class="metro-notification-icon">' +
            '                           <i class="fa fa-{{message.icon}}"></i>' +
            '                       </div>' +
            '                   </div>' +
            '                   <div class="metro-notification-body">' +
            '                       <div class="metro-notification-message" data-detail="{{message.detail}}"><span class="message"  ng-bind-html="message.message"></span> <span class="detail" ng-if="message.showDetail">{{message.detail}}</span></div>' +
            '                   </div>' +
            '               </div>' +
            '           </div>' +
            '           <div class="metro-notification-edit-link" ng-if="allowEdit && message.contentRef"><a ng-click="goTo(message)">Edit {{message.category}}/{{message.id}} <span ng-if="!message.show">(message is hidden)</span>  <span ng-if="message.showDetail">(IIB response shown)</span>  </a></div>' +
            '       </div>' +
            '   </li>' +
            '</ul>',
            link: function (scope) {
                scope.allowEdit = b$.portal.loggedInUserRole === 'admin';
                scope.goTo = function (message) {
                    window.open('/portalserver/cxp-manager/shared-content//_/notifications/' + message.category + '/' + message.id + '?view=content', '_blank');
                };

            }
        };
    };

    exports.metMessageSummary = function () {
        return {
            restrict: 'E',
            scope: {
                messageSummary: '='
            },
            replace: true,
            template: '<div class="metro-notification-summary">' +
            '   <h4>{{heading}}</h4>' +
            '   <div data-ng-repeat="level in messageSummary" ng-show="level.messages.length > 0">' +
            '       <h5><i class="fa fa-{{level.icon}}"></i>{{level.title}}</h5>' +
            '       <p>{{level.description}}</p>' +
            '       <ul>' +
            '           <li data-ng-repeat="message in level.messages track by $index">{{message.itemDescription}} <br ng-if="message.itemDescription"/><span class="detail">{{message.detail}}</span></li>' +
            '       </ul>' +
            '   </div>' +
            '</div>'
        };
    };
});




// WEBPACK FOOTER //
// ./scripts/directives/metNotification.js